import React from 'react';

const BankTransferData = ({amount, user, subscription}) => {
    return (
        <table>
            <tbody>
            <tr className="border">
                <td className="border p-1">Intestato a</td>
                <td className="border p-1">ediliziapp srls</td>
            </tr>
            <tr className="border">
                <td className="border p-1">IBAN</td>
                <td className="border p-1">IT22B0880760330000000853305</td>
            </tr>
            <tr className="border">
                <td className="border p-1">Importo</td>
                <td className="border p-1">{amount} €</td>
            </tr>
            <tr className="border">
                <td className="border p-1">Causale</td>
                <td className="border p-1">{user.email ?? "*la tua email*"} - {subscription.name ?? "*nome abbonamento*"}</td>
            </tr>
            </tbody>
        </table>
    );
};

export default BankTransferData;